module.exports = __webpack_public_path__ + "img/square_af.d19d3996.svg";